"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.token = void 0;
const inspect_1 = require("../utils/inspect");
function token(tree) {
    if (tree.kind === "Tree.leaf") {
        const { token } = tree;
        return token;
    }
    else {
        throw new Error("Expecting Tree.leaf.\n" + `- tree: ${(0, inspect_1.inspect)(tree)}\n`);
    }
}
exports.token = token;
//# sourceMappingURL=tree-token.js.map